import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Ticket, Calendar, CheckCircle, Sparkles, Heart } from 'lucide-react';
export function ProductReveal() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const features = [{
    icon: Ticket,
    text: '30 ready-to-use Memory Tickets (ice cream dates, library adventures, baking, craft time)'
  }, {
    icon: Sparkles,
    text: "A 'First Ticket to Redeem' page (so it starts immediately)"
  }, {
    icon: Calendar,
    text: "A Redemption Tracker that turns 'we should' into 'it’s scheduled'"
  }, {
    icon: Heart,
    text: 'A simple system for choosing the right tickets for mixed ages + your energy level'
  }];
  return <section ref={ref} className="py-20 px-4 md:px-6" data-id="element-208">
      <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-stone-100" data-id="element-209">
        <div className="grid md:grid-cols-2 gap-0" data-id="element-210">
          <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-211">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.6
          }} data-id="element-212">
              <span className="text-coral font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-213">
                Introducing
              </span>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-214">
                Grandma & Me: <br data-id="element-215" />
                Memory Tickets
              </h2>
              <p className="text-warm-gray mb-8 text-lg" data-id="element-216">
                A printable “Anytime / Just Because” coupon book designed for
                grandmas with grandkids ages <strong data-id="element-217">2–13</strong>.
              </p>
              <p className="text-warm-gray mb-8" data-id="element-218">
                You download it, personalize it (fillable), print it, cut the
                tickets, and gift it—today.
              </p>

              <ul className="space-y-4" data-id="element-219">
                {features.map((feature, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -10
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {
                opacity: 0,
                x: -10
              }} transition={{
                delay: 0.3 + index * 0.1,
                duration: 0.4
              }} className="flex items-start gap-3" data-id="element-220">
                    <div className="mt-1 bg-teal/10 p-1.5 rounded-full text-teal shrink-0" data-id="element-221">
                      <feature.icon className="w-4 h-4" data-id="element-222" />
                    </div>
                    <span className="text-charcoal" data-id="element-223">{feature.text}</span>
                  </motion.li>)}
              </ul>
            </motion.div>
          </div>

          <div className="bg-cream p-8 md:p-12 flex items-center justify-center relative overflow-hidden" data-id="element-224">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-coral/5 rounded-full -mr-16 -mt-16" data-id="element-225"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-teal/5 rounded-full -ml-20 -mb-20" data-id="element-226"></div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9,
            rotate: 2
          }} animate={isInView ? {
            opacity: 1,
            scale: 1,
            rotate: 0
          } : {
            opacity: 0,
            scale: 0.9,
            rotate: 2
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="relative z-10 w-full max-w-xs" data-id="element-227">
              {/* Placeholder for a product mockup or illustration if we had another image */}
              <div className="bg-white p-6 rounded-xl shadow-lg border-2 border-dashed border-stone-200 aspect-[3/4] flex flex-col items-center justify-center text-center" data-id="element-228">
                <div className="w-full h-full border-2 border-charcoal p-4 flex flex-col items-center justify-center" data-id="element-229">
                  <h3 className="font-serif text-3xl font-bold text-charcoal mb-2" data-id="element-230">
                    ADMIT ONE
                  </h3>
                  <div className="w-full h-0.5 bg-charcoal my-4" data-id="element-231"></div>
                  <p className="text-xl font-bold text-coral uppercase tracking-widest" data-id="element-232">
                    Ice Cream Date
                  </p>
                  <p className="text-sm text-warm-gray mt-2" data-id="element-233">
                    Redeemable with Grandma
                  </p>
                  <div className="mt-8 flex gap-2" data-id="element-234">
                    <div className="w-2 h-2 rounded-full bg-charcoal" data-id="element-235"></div>
                    <div className="w-2 h-2 rounded-full bg-charcoal" data-id="element-236"></div>
                    <div className="w-2 h-2 rounded-full bg-charcoal" data-id="element-237"></div>
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-4 -right-4 bg-teal text-white px-4 py-2 rounded-full font-bold shadow-lg transform rotate-3" data-id="element-238">
                Printable PDF
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}